module.exports = __webpack_public_path__ + "static/basen-lisc_thumb-4047aebe0e713750591c67d6033f5f54.jpg";